import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '../../shared/components/Layout/AppLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { ViewContextTracker } from './ViewContextTracker';
import { LoginPage } from '../../modules/auth/LoginPage';
import { RegistrationPage } from '../../modules/auth/RegistrationPage';
import { RequestAccessPage } from '../../modules/auth/RequestAccessPage';
import { CompleteSignupPage } from '../../modules/auth/CompleteSignupPage';
import { InviteAcceptPage } from '../../modules/auth/InviteAcceptPage';
import { DashboardPage } from '../../modules/dashboard/DashboardPage';
import { OnboardingPage, OnboardingWizardPage } from '../../modules/onboarding/OnboardingPage';
import { TenantsPage } from '../../modules/tenants/TenantsPage';
import { UsersPage } from '../../modules/users/UsersPage';
import { TagsPage } from '../../modules/tags/TagsPage';
import { ProjectDetail } from '../../modules/projects/ProjectDetail';
import { ValidationFlow } from '../../modules/projects/ValidationFlow';
import { ValidationPage } from '../../modules/validation/ValidationPage';
import { ManagedEntityTypeDetail } from '../../modules/entities/managed-entity-type/ManagedEntityTypeDetail';
import { ItemsPage } from '../../modules/items/ItemsPage';
import { ItemDetailPage } from '../../modules/items/ItemDetailPage';
import { ItemDetailsPage } from '../../modules/item-details/ItemDetailsPage';
import { DocumentEditorPage } from '../../modules/documents-template/DocumentEditorPage';
import { DocumentDetail } from '../../modules/documents/DocumentDetail';
import { DocumentPresentationsPage } from '../../modules/documents/DocumentPresentationsPage';
import { SearchPage } from '../../modules/search/SearchPage';

export function AppRouter() {
  return (
    <>
      <ViewContextTracker />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/request-access" element={<RequestAccessPage />} />
        <Route path="/complete-signup" element={<CompleteSignupPage />} />
        {/* Public: the invitee may have no account yet, so this must sit
            OUTSIDE ProtectedRoute. */}
        <Route path="/invite" element={<InviteAcceptPage />} />
        <Route element={<ProtectedRoute />}>
          {/* Full-screen document editor — own layout, no AppLayout */}
          <Route path="/documents" element={<DocumentEditorPage />} />
          <Route element={<AppLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/onboarding/:projectType" element={<OnboardingWizardPage />} />
            <Route path="/tenants" element={<TenantsPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/tags" element={<TagsPage />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/projects/:id/validation-flow" element={<ValidationFlow />} />
            <Route path="/projects/:id/validation" element={<ValidationPage />} />
            <Route path="/projects/:id/managed-knowledge/:entityType" element={<ManagedEntityTypeDetail />} />
            <Route path="/documents/:id" element={<DocumentDetail />} />
            <Route path="/documents/:id/presentation" element={<DocumentPresentationsPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/items" element={<ItemsPage />} />
            <Route path="/items/:id" element={<ItemDetailPage />} />
            <Route path="/item-details" element={<ItemDetailsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}
